/**
 * Checks wether the given element is inside a shadow DOM
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export default function isLocatedInShadowDom(element) {
  return element.getRootNode() instanceof ShadowRoot;
}